import { forwardRef, useEffect, useState } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import enLocale from 'date-fns/locale/en-US';
import loadable from '@loadable/component';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import Input from '@mui/material/TextField';

const Calendar = forwardRef((props, ref) => {

    const {
        id,
        sx,
        open,
        label,
        onOpen,
        onClose,
        onChange,
        disabled,
        readOnly,
        disableFuture,
        disableMaskedInput,
        inputFormat,
        InputAdornmentProps,
        OpenPickerButtonProps,
        PopperProps,
        DialogProps,
        minDate,
        maxDate,
        value: date
    } = props;

    const [value, setValue] = useState(null);
    const [adapterLocale, setAdapterLocale] = useState(enLocale);
    const userLocale = loadable(locale => import(`date-fns/locale/${locale}/index.js`));
    const currentUser = useRecoilValue(atoms.currentUser);

    const renderInput = (props) => {
        return (
            <Input
                {...props}
                id={id}
                size='small'
                variant='outlined'
                InputProps={{
                    ...props.InputProps,
                    sx: {
                        padding: '0px'
                    }
                }}
                inputProps={{
                    ...props.inputProps,
                    readOnly: true
                }}
                sx={sx}
            />
        )
    };

    useEffect(() => {
        if (currentUser.LanguageCultureCode !== 'en-US') {
            loadLocale(currentUser.LanguageCultureCode, true);
        } else {
            setValue(date);
        }
    }, []);

    useEffect(() => {
        setValue(date);
    }, [date]);

    const loadLocale = (locale, loadFallback) => {
        try {
            userLocale.load(locale).then((locale) => {
                setAdapterLocale(locale);
                setValue(date);
            });
        } catch (error) {
            if (loadFallback) {
                loadLocale(currentUser.LanguageISOCode?.toLowerCase?.(), false);
            } else {
                setValue(date);
                console.error(`Couldn't find user locale while loading the Calendar component. ${error}`);
            }
        }
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={adapterLocale}
        >
            <DatePicker
                id={id}
                sx={sx}
                open={open}
                label={label}
                onOpen={onOpen}
                onClose={onClose}
                onChange={onChange}
                disabled={disabled}
                readOnly={readOnly}
                disableFuture={disableFuture}
                disableMaskedInput={disableMaskedInput}
                inputRef={ref}
                inputFormat={inputFormat}
                InputAdornmentProps={InputAdornmentProps}
                OpenPickerButtonProps={OpenPickerButtonProps}
                PopperProps={PopperProps}
                DialogProps={DialogProps}
                renderInput={renderInput}
                minDate={minDate}
                maxDate={maxDate}
                value={value}
            />
        </LocalizationProvider>
    );
});

export default Calendar;